import createReducer from '../../../../../utils/createReducer';
import { ACTION_PREFIX } from '../../sportsbook-constants';
import selectSportsbookState from '../../sportsbook-state-selector';
import { RootState, ThunkAction } from '../../../../../store/types';
import { Bet } from '../../api/betting-service/betting-service-types';
import { fetchBet } from '../../api/betting-service-api';

type State = {
	isOpen: boolean;
	isLoading: boolean;
	bet?: Bet;
};

// Actions
const OPENED = `${ACTION_PREFIX}SHARE_BET_MODAL/OPENED` as const;
type OpenedAction = {
	type: typeof OPENED;
};

const CLOSED = `${ACTION_PREFIX}SHARE_BET_MODAL/CLOSED` as const;
type ClosedAction = {
	type: typeof CLOSED;
};

const BET_RECEIVED = `${ACTION_PREFIX}SHARE_BET_MODAL/BET_RECEIVED` as const;
type BetReceivedAction = {
	type: typeof BET_RECEIVED;
	payload: { bet: Bet };
};

// Selectors
const selectState = (state: RootState) => selectSportsbookState(state).shareBetModal;
export const selectIsOpen = (state: RootState) => selectState(state).isOpen;
export const selectIsLoading = (state: RootState) => selectState(state).isLoading;
export const selectBet = (state: RootState) => selectState(state).bet;

// Action creators
export const closeShareBetModal = (): ThunkAction<ClosedAction> => dispatch => {
	dispatch({ type: CLOSED });
};

export const openShareBetModal =
	(betId: number): ThunkAction<OpenedAction | BetReceivedAction> =>
	async dispatch => {
		dispatch({ type: OPENED });
		try {
			const bet = await fetchBet(betId);
			dispatch({ type: BET_RECEIVED, payload: { bet } });
		} catch {
			// eslint-disable-next-line no-console
			console.warn(`Failed to fetch bet ${betId}`);
			dispatch(closeShareBetModal());
		}
	};

// Reducers
const initialState: State = {
	isOpen: false,
	isLoading: true,
	bet: undefined
};

const handleOpened = (state: State): State => ({
	...state,
	isOpen: true
});

const handleClosed = (): State => ({
	...initialState
});

const handleBetReceived = (state: State, { payload: { bet } }: BetReceivedAction): State => {
	return {
		...state,
		bet,
		isLoading: false
	};
};

const reducer = createReducer(initialState, {
	[OPENED]: handleOpened,
	[CLOSED]: handleClosed,
	[BET_RECEIVED]: handleBetReceived
});

export default reducer;
